import { baseGetRequest } from '../constant/baseGetRequest';
import {
  GET_MOVIES_FAILURE,
  GET_MOVIES_REQUEST,
  GET_MOVIES_SUCCESS,
} from '../constant/movieList';

export const getAllMovies = (category) => async (dispatch) => {
  try {
    dispatch({ type: GET_MOVIES_REQUEST });
    // const res = await axios.get("https://jsonplaceholder.typicode.com/todos");
    const data = await baseGetRequest(category);
    if (data) {
      dispatch({ type: GET_MOVIES_SUCCESS, payload: data?.data?.results });
      // console.log(data);
    }
  } catch (err) {
    dispatch({ type: GET_MOVIES_FAILURE, payload: err.message });
    // console.log("Error Show--" + err);
  }
};
